import React, { useCallback, useEffect, useState } from "react";
import backArrow from "../../../assets/icons/Back.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import sortIcon from "../../../assets/icons/sort.svg";
import { GoalScoreCard } from "./goalScoreCard";
import whiteSchedule from "../../../assets/icons/whiteSchedule.svg";
import goalScoreService from "../../../api/services/goalScoreService";
import moment from "moment";
import DatePicker from "react-datepicker";
import { useMemo } from "react";
import { useDispatch } from "react-redux";
import { playSong } from "../../common/actions/common.actions";
import { FiSearch } from "react-icons/fi";
import sortArrow from "../../../assets/newIcons/sorting-arrows.png";
import clear from "../../../assets/icons/clear.png";
import { BiSolidCalendar } from "react-icons/bi";
import { LiaSortAmountDownSolid } from "react-icons/lia";
import { MdCancel } from "react-icons/md";
import { GiGoalKeeper } from "react-icons/gi";
import { IoIosArrowBack } from "react-icons/io";
import { BiSort } from "react-icons/bi";

export const GoalScore = ({ setIsLoading }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [goalScore, setgoalScore] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [sortBy, setSortBy] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  //eslint-disable-next-line
  const navigate = useNavigate();

  const handleSongClick = async () => {
    dispatch(playSong());
  };

  const handleBackClick = () => {
    handleSongClick();
    navigate("/dashboard");
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const filteredGoalScore = useMemo(() => {
    return goalScore.filter((item) => {
      const searchTerm = searchInput?.toLowerCase();
      return (
        item.league.toLowerCase().includes(searchTerm) ||
        item.homeTeam.toLowerCase().includes(searchTerm) ||
        item.homeTeamMyan.toLowerCase().includes(searchTerm) ||
        item.awayTeam.toLowerCase().includes(searchTerm) ||
        item.awayTeamMyan.toLowerCase().includes(searchTerm)
      );
    });
  }, [searchInput, goalScore]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    getData(date);
  };

  const handleSearchClick = async () => {
    await handleSongClick();
    setShowSearch(!showSearch);
  };

  const handleSearchInputChange = useCallback((event) => {
    setSearchInput(() => event.target.value);
  }, []);

  const handleClearSearch = () => {
    handleSongClick();
    setSearchInput(""); // Clear the search input
    setShowSearch(false);
  };

  const getData = (date = selectedDate) => {
    setIsLoading(true);
    goalScoreService
      .goalScores({
        startDate: moment(new Date(date)).format("YYYY-MM-DD"),
        endDate: moment(new Date(date)).format("YYYY-MM-DD"),
      })
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          const teamData = data?._data.map((item) => item.team).flat();
          setgoalScore(() => teamData);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.error("API request error:", err);
      });
  };

  const sortedGoalScore = useMemo(() => {
    const sortedData = [...filteredGoalScore];
    if (sortBy) {
      sortedData.sort((a, b) => new Date(b.event) - new Date(a.event));
    } else {
      sortedData.sort((a, b) => new Date(a.event) - new Date(b.event));
    }
    return sortedData;
  }, [filteredGoalScore, sortBy]);

  const handleSortingMatches = () => {
    setSortBy((preSort) => !preSort);
  };
  return (
    <div className="w-full h-[100dvh] flex flex-col bg-gradient-to-br from-[#EAEAEA] via-green-50 to-[#228B22]/10 relative overflow-hidden">
      {/* Football Background Animation */}
      <div className="absolute inset-0 pointer-events-none opacity-20">
        {[...Array(6)].map((_, i) => (
          <div
            key={`goal-line-${i}`}
            className="absolute w-full h-px bg-white opacity-30"
            style={{ top: `${(i + 1) * 16.66}%` }}
          />
        ))}

        {/* Floating Football and Money Icons */}
        {[...Array(8)].map((_, i) => (
          <div
            key={`goal-icon-${i}`}
            className="absolute text-lg opacity-10"
            style={{
              left: `${10 + i * 12}%`,
              top: `${20 + (i % 3) * 25}%`,
              color:
                i % 3 === 0 ? "#228B22" : i % 3 === 1 ? "#FFD700" : "#1E90FF",
              animation: `floatingGoalIcon 8s ease-in-out infinite ${i * 1.5}s`,
            }}
          >
            {i % 3 === 0 ? "⚽" : i % 3 === 1 ? "🥅" : "$"}
          </div>
        ))}
      </div>

      {/* Header */}
      <div className="relative z-40 px-4 py-4 shadow-lg bg-gradient-to-br from-silver via-gray-100 to-silver backdrop-blur-sm">
        <div className="flex items-center justify-between">
          <div className="flex items-center justify-between ">
            <button
              className="flex items-center justify-center w-10 h-10 transition-all duration-300 text-blue-primary hover:bg-crimson/10 rounded-xl"
              onClick={handleBackClick}
            >
              <IoIosArrowBack size={25} />
            </button>
            {!showSearch &&(
              <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-12 h-12 border-2 shadow-lg bg-gradient-to-br from-crimson via-red-primary to-crimson rounded-xl border-golden/40">
                <GiGoalKeeper size={22} className="text-white drop-shadow-lg" />
              </div>
              <h3 className="text-lg font-bold leading-tight text-blue-primary font-dangrek">
                {t("goalScore")}
              </h3>
            </div>
            )}
          </div>

          {/* Search Input */}
          {showSearch &&(
            <div className="relative flex items-center flex-1 mx-3">
              <input
                type="text"
                className="w-full py-2 pl-10 pr-10 bg-white border-2 border-crimson/30 font-breeSerif focus:outline-none focus:ring-2 focus:ring-crimson/50 focus:border-crimson rounded-xl text-blue-primary"
                placeholder="Search"
                value={searchInput}
                onChange={handleSearchInputChange}
              />
              <FiSearch
                size={18}
                className="absolute left-3 text-blue-primary"
              />
              <button className="absolute right-3" onClick={handleClearSearch}>
                <MdCancel
                  size={21}
                  className="transition-colors text-blue-primary hover:text-crimson"
                />
              </button>
            </div> )
          }

          {/* Action Buttons */}
          <div className="flex items-center space-x-2">
            {!showSearch && (
              <>
                {/* Calendar Button */}
                <label
                  htmlFor="goalScoreDate"
                  className="flex items-center justify-center transition-all duration-300 cursor-pointer text-blue-primary hover:bg-crimson/10 rounded-xl"
                >
                  <BiSolidCalendar size={24} />
                </label>
                <DatePicker
                  id="goalScoreDate"
                  selected={selectedDate || new Date()}
                  onChange={handleDateChange}
                  dateFormat="yyyy-MM-dd"
                  withPortal
                  closeOnSelect={true}
                  className="hidden w-2 text-transparent text-white border-none h-9 bg-inherit focus:outline-none"
                />

                {/* Sort Button */}
                <button
                  className="flex items-center justify-center w-10 h-10 transition-all duration-300 text-blue-primary hover:bg-crimson/10 rounded-xl"
                  onClick={handleSortingMatches}
                >
                  <BiSort size={22} />
                </button>
              </>
            )}

            {/* Search Toggle Button */}
            <button
              onClick={handleSearchClick}
              className="flex items-center justify-center w-10 h-10 transition-all duration-300 text-blue-primary hover:bg-crimson/10 rounded-xl"
            >
              <FiSearch size={22} />
            </button>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 right-0 h-1 shadow-lg bg-gradient-to-r from-crimson via-golden to-crimson"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 p-4 overflow-auto bg-white/50 backdrop-blur-sm">
        <GoalScoreCard data={sortedGoalScore} />
      </div>
    </div>
  );
};
